import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { formatTimestamp } from './formatUtils';

const ChatHeader = ({
  onToggleSidebar,
  onNewChat,
  isLoading,
  isTyping,
  messages = [],
  promptInfo
}) => {
  return (
    <div className="bg-gray-800 border-b border-gray-700 p-3 flex justify-between items-center shadow-sm">
      <div className="flex items-center">
        <button
          onClick={onToggleSidebar}
          className="mr-1 min-w-[44px] min-h-[44px] flex items-center justify-center text-gray-400 hover:text-white active:bg-gray-700/50 rounded-lg transition-colors"
          aria-label="Chat history"
          title="Chat History"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h2 className="text-gray-100 font-medium text-base">{promptInfo?.name || 'Your Coach'}</h2>
      </div>
      <div className="flex items-center gap-2">
        {messages.length > 0 && (
          <button
            onClick={() => {
              const dateStr = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
              let md = `# Coach Chat - ${dateStr}\n\n`;
              
              messages.forEach(m => {
                const role = m.role === 'user' ? 'You' : 'Runium AI';
                const time = formatTimestamp(m.created_at);
                // Strip emojis and clean content
                let cleanContent = m.content.replace(/<[^>]*>/g, '').trim();
                // Remove common emojis and all Unicode emojis
                cleanContent = cleanContent
                  .replace(/✅|✓/g, '(checkmark)')
                  .replace(/🏃[‍♂️♀️]?/g, '(runner)')
                  .replace(/🔥/g, '(fire)')
                  .replace(/❤️|♥️/g, '(heart)')
                  .replace(/[\u{1F300}-\u{1F9FF}]/gu, '') // Remove all emojis
                  .trim();
                md += `**${role}** - ${time}\n${cleanContent}\n\n---\n\n`;
              });
              
              const blob = new Blob([md], { type: 'text/markdown;charset=utf-8' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `coach-chat-${new Date().toISOString().slice(0,10)}.md`;
              a.click();
              URL.revokeObjectURL(url);
            }}
            className="flex items-center gap-1.5 text-sm bg-gray-700 text-gray-300 hover:bg-gray-600 active:bg-gray-700/80 px-3 min-h-[44px] rounded-full transition-colors active:scale-95"
            title="Download full conversation as Markdown" aria-label="Download chat as Markdown"
            disabled={isLoading || isTyping}
          >
            <ArrowDownTrayIcon className="h-4 w-4" />
            <span className="hidden sm:inline">Chat</span>
          </button>
        )}
        <button
          onClick={onNewChat}
          className="flex items-center gap-1.5 text-sm bg-gray-700 text-blue-400 hover:bg-gray-600 active:bg-gray-700/80 px-3 min-h-[44px] rounded-full transition-colors active:scale-95"
          disabled={isLoading || isTyping}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          New Chat
        </button>
      </div>
    </div>
  );
};

export default ChatHeader; 